// extracted by mini-css-extract-plugin
module.exports = {"popup":"user-filter_popup__1aqRL","popup_menu_added_styles":"user-filter_popup_menu_added_styles__2fhSQ"};